/* eslint-disable max-len */
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocationIcon from '@mui/icons-material/LocationCity';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/AddBoxOutlined';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import AddchartIcon from '@mui/icons-material/Addchart';
import RouteIcon from '@mui/icons-material/AltRouteOutlined';
import AppsIcon from '@mui/icons-material/Apps';
import PickupIcon from '@mui/icons-material/ArrowForward';
import BuildIcon from '@mui/icons-material/Build';
import DutiesCostCalculator from '@mui/icons-material/CalculateOutlined';
import { FaBarcode } from '@react-icons/all-files/fa/FaBarcode';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ImportIcon from '@mui/icons-material/ImportExport';
import LabelIcon from '@mui/icons-material/Label';
import LanguageIcon from '@mui/icons-material/Language';
import WeightIcon from '@mui/icons-material/LineWeight';
import ListIcon from '@mui/icons-material/ListAltOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LogingLogsIcon from '@mui/icons-material/LoginOutlined';
import MoneyIcon from '@mui/icons-material/MonetizationOn';
import PricingIcon from '@mui/icons-material/Money';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import GlobeIcon from '@mui/icons-material/Public';
import SecurityIcon from '@mui/icons-material/Security';
// import PdfIcon from '@mui/icons-material/PictureAsPdf';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StoreIcon from '@mui/icons-material/Store';
import UsersIcon from '@mui/icons-material/SupervisedUserCircle';
import TrackingIcon from '@mui/icons-material/TrackChanges';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import ParcelsIcon from '@mui/icons-material/Work';
import KeyIcon from '@mui/icons-material/Key';
// import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MultiRouteIcon from '@mui/icons-material/AccountTreeRounded';
import { IoIosQrScanner } from '@react-icons/all-files/io/IoIosQrScanner';
import { IoIosAirplane } from '@react-icons/all-files/io/IoIosAirplane';
import { IoIosBarcode } from '@react-icons/all-files/io/IoIosBarcode';
import { IoIosBriefcase } from '@react-icons/all-files/io/IoIosBriefcase';
import { IoMdAirplane } from '@react-icons/all-files/io/IoMdAirplane';

import QuickbooksIcon from 'components/Icons/Quickbooks';
import TrackingCodeIcon from '@mui/icons-material/Code';
import { MuiPage } from './pages';

const pagesBR: readonly MuiPage[] = [
  {
    label: 'Dashboard',
    icon: DashboardIcon,
    pathname: '/admin/dashboard',
    roles: [
      'admin',
      'customer',
      'wholesaler',
      'retailer',
      'reseller',
      'reseller_customer',
      'wholesaler_customer',
      'dev',
      'accounting',
      'accounting_chief',
      'warehouse',
      'analyst',
      'shipping_marketplace',
    ],
  },
  {
    label: 'Contas',
    icon: UsersIcon,
    roles: [
      'admin',
      'accounting',
      'accounting_chief',
      'warehouse',
      'reseller',
      'retailer',
      'wholesaler',
    ],
    children: [
      {
        label: 'Usuários',
        icon: AccountCircleIcon,
        pathname: '/admin/users',
        roles: ['admin', 'accounting', 'accounting_chief'],
      },
      {
        label: 'Contas',
        icon: AccountTreeIcon,
        pathname: '/admin/accounts',
        roles: ['admin', 'accounting', 'accounting_chief'],
      },
      // {
      //   label: 'Accounts pending',
      //   icon: ManageAccountsIcon,
      //   pathname: '/admin/accounts/pending_review',
      //   roles: ['admin', 'accounting', 'accounting_chief'],
      // },
      {
        label: 'Etiqueta Branca',
        icon: LabelIcon,
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
        pathname: '/admin/white-labels',
      },
      {
        label: 'Códigos HS Autorizados',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes-restrictions-auth',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Boas categorias',
        icon: () => <AppsIcon />,
        pathname: '/admin/good-categories',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Categorias de Código HS',
        icon: () => <AppsIcon />,
        pathname: '/admin/hs-code-categories',
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler', 'reseller_customer'],
      },
      {
        label: 'Códigos HS Categorização',
        icon: () => <AppsIcon />,
        pathname: '/admin/account-hs-code-categorization',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Códigos HS Intercâmbio',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes-interchange',
        roles: ['admin', 'warehouse'],
      },
    ],
  },
  {
    label: 'Encomendas',
    icon: ParcelsIcon,
    roles: [
      'admin',
      'warehouse',
      'analyst',
      'reseller',
      'retailer',
      'wholesaler',
      'reseller_customer',
      'read_only',
    ],
    badge: true,
    badgeCallback: 'loadParcelsPendingReview',
    badgeVar: 'countParcelsPendingReview',
    children: [
      {
        label: 'Nova',
        icon: AddIcon,
        pathname: '/admin/edit-parcel',
        roles: [
          'admin',
          'customer',
          'wholesaler',
          'retailer',
          'reseller',
          'reseller_customer',
          'wholesaler_customer',
          'dev',
          'accounting',
          'accounting_chief',
          'warehouse',
          'analyst',
          'shipping_marketplace',
        ],
      },
      {
        label: 'Todas as Encomendas',
        icon: ListIcon,
        pathname: '/admin/parcels',
      },
      {
        label: 'Aguardando Envio',
        icon: ListIcon,
        pathname: '/admin/awaiting-shipping',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Aguardando Envio',
        icon: ListIcon,
        pathname: '/admin/awaiting-shipping',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Importações',
        icon: ImportIcon,
        pathname: '/admin/parcel-imports',
        roles: [
          'admin',
          'customer',
          'wholesaler',
          'retailer',
          'reseller',
          'reseller_customer',
          'wholesaler_customer',
          'dev',
          'accounting',
          'accounting_chief',
          'warehouse',
          'analyst',
          'shipping_marketplace',
        ],
      },
      {
        label: 'Importar Encomendas 3PL',
        icon: ImportIcon,
        pathname: '/admin/parcel-imports-dl-packet',
        roles: ['admin', 'import_3pl_parcels'],
      },
      {
        label: 'Scan Zone',
        icon: IoIosQrScanner,
        pathname: '/admin/parcel-scan',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Scan Zone Trial',
        icon: IoIosQrScanner,
        pathname: '/admin/parcel-scanv2',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Verificação de origem',
        icon: IoIosQrScanner,
        pathname: '/admin/origin-scan',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Eventos de Rastreamento',
        icon: TrackingIcon,
        pathname: '/admin/tracking-events',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Calculadora de Impostos e Taxas',
        icon: DutiesCostCalculator,
        pathname: '/admin/duties-cost-calculator',
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
      },
      {
        label: 'Ajuste de Peso',
        icon: BuildIcon,
        pathname: '/admin/parcel-tools',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Encomendas Tributadas Pendentes',
        icon: ListIcon,
        pathname: '/admin/parcels/taxed-pending',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Encomendas Tributadas Pagas',
        icon: ListIcon,
        pathname: '/admin/parcels/taxed-paid',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Central de reconciliação de pagamentos da Amazon',
        icon: ListIcon,
        pathname: '/admin/parcels-invoice-xml',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Pickups',
    icon: PickupIcon,
    roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
    children: [
      {
        label: 'Solicitar Coleta',
        icon: AddIcon,
        pathname: '/admin/new-pickup',
      },
      {
        label: 'Pendente',
        icon: ListIcon,
        pathname: '/admin/pickups/created',
      },
      {
        label: 'Concluído',
        icon: ListIcon,
        pathname: '/admin/pickups/processed',
      },
      {
        label: 'Scan',
        icon: ListIcon,
        pathname: '/admin/pickups/scan-pickup',
      },
    ],
  },
  {
    label: 'Recipientes',
    icon: (fontSize) => <FaBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin', 'warehouse', 'analyst', 'wholesaler'],
    children: [
      {
        label: 'Dashboard',
        icon: DashboardIcon,
        pathname: '/admin/receptacle-dashboard',
      },
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/receptacle-list',
      },
    ],
  },
  {
    label: 'Tipos de Receptáculos',
    icon: (fontSize) => <FaBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin'],
    children: [
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/receptacle-type-list',
      },
    ],
  },
  {
    label: 'Despachos',
    icon: (fontSize) => <IoIosBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin', 'warehouse', 'analyst', 'wholesaler'],
    children: [
      {
        label: 'Carga',
        icon: ListIcon,
        pathname: '/admin/load-dispatch',
      },
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/dispatch-list',
      },
      {
        label: 'Pendente',
        icon: ListIcon,
        pathname: '/admin/dispatches-pending',
      },
      {
        label: 'Processado',
        icon: ListIcon,
        pathname: '/admin/dispatch-shipped',
      },
      {
        label: 'Airway Bills',
        icon: ListIcon,
        pathname: '/admin/airway-bills',
      },
    ],
  },
  {
    label: 'Não Entregável',
    icon: LocalShippingIcon,
    roles: ['admin', 'warehouse', 'analyst', 'reseller', 'retailer'],
    // pathname: '/admin/parcels-undeliverable',
    badge: true,
    badgeCallback: 'loadUndeliverable',
    badgeVar: 'countUndeliverable',
    children: [
      // {
      //   label: 'Processado',
      //   icon: ListIcon,
      //   pathname: '/admin/parcels-undeliverable/processed',
      // },
      // {
      //   label: 'Ação Necessária',
      //   icon: ListIcon,
      //   pathname: '/admin/parcels-undeliverable/action-required',
      // },
      {
        label: 'Todas as Encomendas',
        icon: ListIcon,
        pathname: '/admin/parcels-undeliverable',
      },
    ],
  },
  // {
  //   label: 'Invoices',
  //   pathname: '/admin/invoices',
  //   icon: PdfIcon,
  // },
  {
    label: 'Relatórios',
    icon: AccountBalanceIcon,
    roles: ['admin', 'accounting', 'accounting_chief'],
    children: [
      {
        label: 'Relatório de Faturamento Contábil',
        icon: ListIcon,
        pathname: '/admin/reports',
      },
      {
        label: 'AMIF',
        icon: ListIcon,
        pathname: '/admin/amif',
      },
      {
        label: 'Colômbia 4-72 Manifesto',
        icon: ListIcon,
        pathname: '/admin/reports-colombia-manifest',
      },
      // {
      //   label: 'Import Unitizers Dispatches Report',
      //   icon: ListIcon,
      //   pathname: '/admin/unitizers-dispatches-report',
      // },
      {
        label: 'Relatório de Despachos de Importação',
        icon: ListIcon,
        pathname: '/admin/dispatches-report',
      },
      {
        label: 'Reclamações',
        icon: ListIcon,
        pathname: '/admin/claims',
      },
      {
        label: 'BPX KPI',
        icon: ListIcon,
        pathname: '/admin/bpx-kpi',
      },
      {
        label: 'Customs Alerts',
        icon: ListIcon,
        pathname: '/admin/customs-alerts',
      },
    ],
  },
  {
    label: 'Configurações',
    icon: SettingsIcon,
    roles: ['admin'],
    children: [
      {
        label: 'Zonas',
        icon: LanguageIcon,
        children: [
          {
            label: 'Países',
            icon: GlobeIcon,
            pathname: '/admin/rates-countries',
          },
          {
            label: 'Estados',
            icon: ListIcon,
            pathname: '/admin/rates-states',
          },
          {
            label: 'Códigos Postais',
            icon: ListIcon,
            pathname: '/admin/rates-postalcodes',
          },
        ],
      },
      {
        label: 'Depósitos de Serviço',
        icon: (fontSize) => <PricingIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/service-deposits',
      },
      {
        label: 'Preços',
        icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        children: [
          {
            label: 'Tabela de Preços',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/list-pricing',
          },
          {
            label: 'Compor Preços',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/compose-pricing',
          },
          {
            label: 'Compor Custos',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/compose-costs',
          },
          {
            label: 'Pesos',
            icon: FitnessCenterIcon,
            pathname: '/admin/weights',
          },
          {
            label: 'Faixas de Preço',
            icon: MoneyIcon,
            pathname: '/admin/money-ranges',
          },
          {
            label: 'Tarifas',
            icon: AddchartIcon,
            pathname: '/admin/tariffs',
          },
          {
            label: 'Marcação',
            icon: TrendingUpIcon,
            pathname: '/admin/markup',
          },
          {
            label: 'Service Area Tariffs',
            icon: CompareArrowsIcon,
            pathname: '/admin/services-areas-tariffs',
          },
          {
            label: 'Custos',
            icon: WeightIcon,
            pathname: '/admin/services-areas-weights-costs',
          },
          {
            label: 'Custos do Seguro',
            icon: VerifiedUser,
            pathname: '/admin/services-areas-insurance-costs',
          },
          {
            label: 'Sobretaxas',
            icon: PlusOneIcon,
            pathname: '/admin/services-areas-surcharges-costs',
          },
        ],
      },
      {
        label: 'Serviços',
        icon: ListIcon,
        children: [
          {
            label: 'Serviços de recolha',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-service-pickup',
          },
          {
            label: 'Serviços Internos',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/internal-services',
          },
          {
            label: 'Roteamento de Serviços Internos',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/internal-services-services',
          },
          {
            label: 'Serviços',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/services',
          },
          {
            label: 'Serviços por Países',
            icon: (fontSize) => <GlobeIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-countries',
          },
          {
            label: 'Opções de Serviço',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-options',
          },
          {
            label: 'Rotas de Serviço',
            icon: (fontSize) => <RouteIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-routes',
          },
          {
            label: 'Etapas da Rota de Serviço',
            icon: (fontSize) => (
              <MultiRouteIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />
            ),
            pathname: '/admin/service-route-legs',
          },
          {
            label: 'Códigos Harmonizados Restritos',
            icon: () => <AppsIcon />,
            pathname: '/admin/harmonized-codes-restrictions',
          },
        ],
      },
      {
        label: 'Códigos Harmonizados',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes',
      },
      {
        label: 'Serviços Externos',
        icon: ListIcon,
        children: [
          {
            label: 'Service Providers',
            icon: ListIcon,
            pathname: '/admin/rates-service-providers',
          },
          {
            label: 'Serviços',
            icon: ListIcon,
            pathname: '/admin/rates-services',
          },
          {
            label: 'Services Areas Tariffs',
            icon: ListIcon,
            pathname: '/admin/rates-services-areas-tariffs',
          },
          {
            label: 'Services Areas',
            icon: ListIcon,
            pathname: '/admin/rates-services-areas',
          },
          {
            label: 'Regras dos Serviços',
            icon: ListIcon,
            pathname: '/admin/rates-services-rules',
          },
          {
            label: 'Tipos de Regras de Serviços',
            icon: ListIcon,
            pathname: '/admin/rates-services-rules-types',
          },
          {
            label: 'Services Providers Destinations',
            icon: ListIcon,
            pathname: '/admin/rates-services-providers-destinations',
          },
          {
            label: 'Services Providers Countries',
            icon: ListIcon,
            pathname: '/admin/rates-services-providers-countries',
          },
        ],
      },
      {
        label: 'Aeroportos',
        icon: (fontSize) => <IoIosAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airports',
      },
      {
        label: 'Rotas Aeroportuárias',
        icon: (fontSize) => <IoIosAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airport-routes',
      },
      {
        label: 'Airports Offices',
        icon: (fontSize) => <IoIosBriefcase style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airports-offices',
      },
      {
        label: 'Companhias Aéreas',
        icon: (fontSize) => <IoMdAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airlines',
      },
      {
        label: 'Rastreamento',
        icon: TrackingIcon,
        children: [
          {
            label: 'Códigos de Rastreamento',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes',
          },
          {
            label: 'Códigos de Rastreamento Clientes',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes-customers',
          },
          {
            label: 'Códigos de Rastreamento Fornecedores',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes-vendors',
          },
          {
            label: 'Localizações Limpas',
            icon: TrackingCodeIcon,
            pathname: '/admin/cleaned-locations',
          },
        ],
      },
      {
        label: 'Restrições de Conta',
        icon: AccountTreeIcon,
        pathname: '/admin/account-service-restrictions',
      },
      {
        label: 'Account Parcel Limit Price',
        icon: AccountTreeIcon,
        pathname: '/admin/account-service-price-limits',
      },
      {
        label: 'Endereços',
        icon: LocationIcon,
        children: [
          {
            label: 'Endereços',
            icon: LocationIcon,
            pathname: '/admin/addresses',
          },
          {
            label: 'Detalhes do Endereço',
            icon: LocationIcon,
            pathname: '/admin/address-details',
          },
        ],
      },
      {
        label: 'Estações de Entrega',
        icon: AccountTreeIcon,
        pathname: '/admin/dropoff-stations',
      },
      {
        label: 'Instalações',
        icon: AccountTreeIcon,
        children: [
          {
            label: 'Lista de Instalações',
            icon: TrackingCodeIcon,
            pathname: '/admin/facilities',
          },
          {
            label: 'Regras das Instalações',
            icon: TrackingCodeIcon,
            pathname: '/admin/facilities-inbound-rules',
          },
        ],
      },
      {
        label: 'Quickbooks',
        icon: (fontSize) => <QuickbooksIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/quickbooks',
      },
      // {
      //   label: 'Inbound Countries',
      //   icon: (fontSize) => <IoIosGlobe style={{ fill: '#fff' , fontSize: fontSize || 14 }} />,
      //   pathname: '/admin/inbound-countries'
      // },
    ],
  },
  {
    label: 'Loja Amazon',
    icon: StoreIcon,
    roles: ['admin', 'reseller', 'retailer', 'wholesaler'],
    children: [
      {
        label: 'Autorização',
        icon: KeyIcon,
        pathname: '/admin/stores/amazon/authorization',
      },
      {
        label: 'Pedidos',
        icon: ShoppingCartIcon,
        pathname: '/admin/stores/amazon/orders',
      },
    ],
  },
  {
    label: 'Lojas',
    icon: StoreIcon,
    roles: ['admin', 'reseller', 'retailer', 'wholesaler', 'reseller_customer'],
    children: [
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/stores',
      },
      {
        label: 'Nova Loja',
        icon: AddBusinessIcon,
        pathname: '/admin/stores/new',
      },
      {
        label: 'Pedidos',
        icon: ShoppingCartIcon,
        pathname: '/admin/store-orders',
      },
    ],
  },
  {
    label: 'Segurança',
    icon: SecurityIcon,
    roles: ['admin'],
    children: [
      {
        label: 'Registros de Login',
        icon: LogingLogsIcon,
        pathname: '/admin/login-logs',
      },
    ],
  },
];

export default pagesBR;
